import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import './Registro_contenido.css';

const Registro_contenido = () => {
  const [formData, setFormData] = useState({
    email: '',
    confirmEmail: '',
    password: '',
    confirmPassword: ''
  });
  
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [mensaje, setMensaje] = useState('');
  const [contador, setContador] = useState(0);
  const [captchaToken, setCaptchaToken] = useState(null);
  const captchaRef = useRef(null);
  const [validations, setValidations] = useState({
    emailMatch: false,
    passwordLength: false,
    passwordUppercase: false,
    passwordLowercase: false,
    passwordNumber: false,
    passwordSpecial: false,
    passwordMatch: false
  });
  
  const navigate = useNavigate();

  // Validar en tiempo real cuando cambian los campos
  useEffect(() => {
    const newValidations = {
      emailMatch: formData.email !== '' && formData.confirmEmail !== '' && formData.email === formData.confirmEmail,
      passwordLength: formData.password.length >= 12,
      passwordUppercase: (formData.password.match(/[A-Z]/g) || []).length >= 2,
      passwordLowercase: /[a-z]/.test(formData.password),
      passwordNumber: /\d/.test(formData.password),
      passwordSpecial: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(formData.password),
      passwordMatch: formData.password !== '' && formData.confirmPassword !== '' && formData.password === formData.confirmPassword
    };
    setValidations(newValidations);
  }, [formData]);

  // Manejar cambios en los inputs
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    // Limpiar errores al escribir
    if (errors[name]) {
      setErrors({ ...errors, [name]: '' });
    }
  };

  // Validar formulario antes de enviar
  const validateForm = () => {
    const newErrors = {};

    // Validar email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email) {
      newErrors.email = 'El correo es requerido';
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = 'El correo no es válido';
    }

    // Validar confirmación de email
    if (!formData.confirmEmail) {
      newErrors.confirmEmail = 'Debe confirmar el correo';
    } else if (formData.email !== formData.confirmEmail) {
      newErrors.confirmEmail = 'Los correos no coinciden';
    }

    // Validar contraseña
    if (!formData.password) {
      newErrors.password = 'La contraseña es requerida';
    } else if (formData.password.length < 12) {
      newErrors.password = 'La contraseña debe tener al menos 12 caracteres';
    } else if ((formData.password.match(/[A-Z]/g) || []).length < 2) {
      newErrors.password = 'La contraseña debe tener al menos 2 letras mayúsculas';
    } else if (!/[a-z]/.test(formData.password)) {
      newErrors.password = 'La contraseña debe tener al menos 1 letra minúscula';
    } else if (!/\d/.test(formData.password)) {
      newErrors.password = 'La contraseña debe tener al menos 1 número';
    } else if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(formData.password)) {
      newErrors.password = 'La contraseña debe tener al menos 1 carácter especial';
    }

    // Validar confirmación de contraseña
    if (!formData.confirmPassword) {
      newErrors.confirmPassword = 'Debe confirmar la contraseña';
    } else if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = 'Las contraseñas no coinciden';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Enviar formulario
  const handleSubmit = async (e) => {
    e.preventDefault();
    setMensaje('');

if (!validateForm()) {
      setMensaje('Por favor corrige los errores del formulario');
      return;
    }

    if (!captchaToken) {
      setMensaje('Por favor confirma que no eres un robot.');
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_REGISTRO_CONTENIDO_URL}/Envioput.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
body: JSON.stringify({
          email: formData.email,
          password: formData.password,
          captcha_token: captchaToken
        })
      });

      const data = await response.json();

if (data.success) {
        setMensaje('✓ Registro exitoso. Bienvenido a Ulalaaa!');
setFormData({
          email: '',
          confirmEmail: '',
          password: '',
          confirmPassword: ''
        });
        setCaptchaToken(null);
        if (captchaRef.current) captchaRef.current.reset();
        // Contador de 10 segundos
        setContador(10);
        let seg = 10;
        const intervalo = setInterval(() => {
          seg--;
          setContador(seg);
          if (seg <= 0) {
            clearInterval(intervalo);
            navigate('/acceso-publicar');
          }
        }, 1000);
      } else {
        setMensaje('✗ Error: ' + data.message);
      }
    } catch (error) {
      console.error('Error:', error);
      setMensaje('✗ Error de conexión con el servidor');
    }
  };

  return (
    <>
      <div className="registro-contenido-container">
      <div className="registro-contenido-card">
        <h1 className="registro-contenido-title">Bienvenida/o a Ulalaaa</h1>
        <p className="registro-contenido-subtitle">"Configura tu acceso a la plataforma"</p>

        <form onSubmit={handleSubmit} className="registro-contenido-form">
          
          {/* Email */}
          <div className="form-group-contenido">
            <label className="form-label-contenido">
              Ingresa tu correo <span className="required-contenido">:</span>
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className={`form-input-contenido ${errors.email ? 'input-error-contenido' : ''} ${validations.emailMatch ? 'input-success-contenido' : ''}`}
            />
            {formData.email && formData.confirmEmail && (
              <div className={`validation-message-contenido ${validations.emailMatch ? 'validation-success' : 'validation-pending'}`}>
                {validations.emailMatch ? '✓ Correos coinciden' : '⚠ Coincidir correos'}
              </div>
            )}
            {errors.email && <span className="error-message-contenido">{errors.email}</span>}
          </div>

          {/* Confirma Email */}
          <div className="form-group-contenido">
            <label className="form-label-contenido">
              Repite tu correo <span className="required-contenido">:</span>
            </label>
            <input
              type="email"
              name="confirmEmail"
              value={formData.confirmEmail}
              onChange={handleChange}
              className={`form-input-contenido ${errors.confirmEmail ? 'input-error-contenido' : ''} ${validations.emailMatch ? 'input-success-contenido' : ''}`}
            />
            {formData.email && formData.confirmEmail && (
              <div className={`validation-message-contenido ${validations.emailMatch ? 'validation-success' : 'validation-pending'}`}>
                {validations.emailMatch ? '✓ Correos coinciden' : '⚠ Coincidir correos'}
              </div>
            )}
            {errors.confirmEmail && <span className="error-message-contenido">{errors.confirmEmail}</span>}
          </div>

          {/* Línea divisoria */}
          <div className="divider-contenido"></div>

          {/* Contraseña */}
          <div className="form-group-contenido">
            <label className="form-label-contenido">
              Contraseña <span className="required-contenido">:</span>
            </label>
            <div className="password-input-container">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                value={formData.password}
                onChange={handleChange}
                className={`form-input-contenido ${errors.password ? 'input-error-contenido' : ''}`}
              />
              <button
                type="button"
                className="toggle-password-btn"
                onClick={() => setShowPassword(!showPassword)}
                aria-label="Mostrar contraseña"
              >
                {showPassword ? '👁️' : '👁️‍🗨️'}
              </button>
            </div>
            {formData.password && (
              <div className="password-requirements">
                <div className={`requirement-item ${validations.passwordLength ? 'requirement-met' : ''}`}>
                  {validations.passwordLength ? '✓' : '○'} 12 caracteres como mínimo
                </div>
                <div className={`requirement-item ${validations.passwordUppercase ? 'requirement-met' : ''}`}>
                  {validations.passwordUppercase ? '✓' : '○'} Dos letras mayúsculas como mínimo
                </div>
                <div className={`requirement-item ${validations.passwordLowercase ? 'requirement-met' : ''}`}>
                  {validations.passwordLowercase ? '✓' : '○'} Una letra minúscula como mínimo
                </div>
                <div className={`requirement-item ${validations.passwordNumber ? 'requirement-met' : ''}`}>
                  {validations.passwordNumber ? '✓' : '○'} Un número como mínimo
                </div>
                <div className={`requirement-item ${validations.passwordSpecial ? 'requirement-met' : ''}`}>
                  {validations.passwordSpecial ? '✓' : '○'} Un carácter especial como mínimo (. , - _ etc)
                </div>
              </div>
            )}
            {errors.password && <span className="error-message-contenido">{errors.password}</span>}
          </div>

          {/* Repite Contraseña */}
          <div className="form-group-contenido">
            <label className="form-label-contenido">
              Repite Contraseña <span className="required-contenido">:</span>
            </label>
            <div className="password-input-container">
              <input
                type={showConfirmPassword ? "text" : "password"}
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
                className={`form-input-contenido ${errors.confirmPassword ? 'input-error-contenido' : ''} ${validations.passwordMatch ? 'input-success-contenido' : ''}`}
              />
              <button
                type="button"
                className="toggle-password-btn"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                aria-label="Mostrar contraseña"
              >
                {showConfirmPassword ? '👁️' : '👁️‍🗨️'}
              </button>
            </div>
            {formData.password && formData.confirmPassword && (
              <div className={`validation-message-contenido ${validations.passwordMatch ? 'validation-success' : 'validation-pending'}`}>
                {validations.passwordMatch ? '✓ Contraseñas coinciden' : '⚠ Coincidir clave'}
              </div>
            )}
            {errors.confirmPassword && <span className="error-message-contenido">{errors.confirmPassword}</span>}
          </div>

          {/* Botón Enviar */}
<div className="button-container-contenido">
            <div style={{display:'flex', justifyContent:'center', marginBottom:'16px'}}>
              <ReCAPTCHA
                ref={captchaRef}
                sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                onChange={(token) => setCaptchaToken(token)}
                onExpired={() => setCaptchaToken(null)}
                theme="dark"
                hl="es"
              />
            </div>
            <button type="submit" className="btn-enviar-contenido">
              ENVIAR
            </button>
          </div>

{/* Mensaje de respuesta - Overlay para éxito */}
{mensaje && mensaje.includes('✓') && (
  <div className="mensaje-overlay">
    <div className="mensaje-overlay-content">
      <h1 className="mensaje-overlay-titulo">{'¡REGISTRO EXITOSO!'}</h1>
      <h2 className="mensaje-overlay-subtitulo">{'Bienvenida/o a Ulalaaa'}</h2>
      <p className="mensaje-overlay-texto">
        {'Tu cuenta fue creada. Revisa tu correo y haz clic en el enlace de verificaci\u00F3n para activar tu cuenta.'}<br/><br/>
        <strong style={{color:'#ffcc00'}}>{'No podr\u00E1s iniciar sesi\u00F3n hasta verificar tu email.'}</strong>
      </p>
      <p style={{marginTop:'16px', fontSize:'18px', color:'#fff'}}>
        {'Redirigiendo en '}<strong style={{color:'#ffcc00', fontSize:'24px'}}>{contador}</strong>{' segundos...'}
      </p>
    </div>
  </div>
)}

{/* Mensaje de error normal */}
{mensaje && !mensaje.includes('✓') && (
  <div className="mensaje-contenido mensaje-error-contenido">
    {mensaje}
  </div>
)}
        </form>
      </div>
</div>

      {/* Footer */}
      <footer className="home-footer">
        <div className="home-footer-top">
          <div className="home-footer-redes">
            <a href="https://www.instagram.com/ulalaaaoficial" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://www.tiktok.com/@ulalaaaoficial2" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-tiktok"></i>
            </a>
            <a href="https://www.youtube.com/@ulalaaaoficial" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-youtube"></i>
            </a>
            <a href="https://wa.me/56929674732" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-whatsapp"></i>
            </a>
            <a href="#" className="home-footer-social-link">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{width:'22px',height:'22px'}}>
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.259 5.63 5.905-5.63zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
            <a href="https://t.me/+56929674732" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-telegram"></i>
            </a>
          </div>
          <div className="home-footer-logo">
            <img
              src={`${process.env.REACT_APP_UPLOADS_URL}/logotipo_new8.jpg`}
              alt="Ulalaaa Logo"
              className="home-footer-logo-img"
            />
          </div>
          <div className="home-footer-legal-links">
            <a href="/textos-legales#terminos" className="home-footer-legal-btn">Información Legal - Términos y Condiciones</a>
            <a href="/textos-legales#privacidad" className="home-footer-legal-btn">Política de Privacidad</a>
          </div>
        </div>
        <div className="home-footer-texto">
          Ulalaaa, es un sitio web exclusivo para mayores de 18 años, tanto para las personas publicadas como las que lo visitan, las personas publicadas son verificadas de forma rigurosa, el cual han dado su consentimiento para ser publicadas, este sitio no es una agencia, es solo un medio publicitario que no interviene con ninguna relación laboral con las personas publicadas.
        </div>
        <div className="home-footer-copyright">
          ©2026 Ulalaaa - Todos los derechos Reservados.
        </div>
      </footer>
    </>
  );
};

export default Registro_contenido;